<template>
  <div class="mini-calendar__event">
    <div class="mini-calendar__event-date">
      <span class="mini-calendar__event-month">
        {{ formatDate(event.date.start.date, "MMM") }}
      </span>
      <span class="mini-calendar__event-day">
        {{ formatDate(event.date.start.date, "DD") }}
      </span>
    </div>
    <div class="mini-calendar__event-main">
      <div class="mini-calendar__event-media">
        <img v-lazy="event.image.image_sizes.large" :alt="event.summary" />
      </div>
      <div class="mini-calendar__event-content">
        <h2 class="mini-calendar__event-title">
          <a :href="getPath(event.url)">{{ event.title }}</a>
        </h2>
        <div class="mini-calendar__event-summary">
          <div
            class="mini-calendar__event-caption"
            v-html="event.summary"
          ></div>
        </div>
        <div class="mini-calendar__event-time">
          {{ event.date.all_day == "1" ? "All Day" : event.date.start.time }}
        </div>
        <div class="mini-calendar__event-social">
          <div class="mini-calendar__event-line">
            <a :href="getPath(event.url)" class="fancy-link"
              >View Event</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import MiniCalenderEventSocial from './mini-calendar-event-social.vue'
import moment from "moment";
import { mapGetters } from "vuex";
import { BASE_URL } from "@/utils/config";

export default {
  name: "MiniCalenderEvent",
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["date_range"]),
  },
  methods: {
    getPath(url) {
      return BASE_URL + url
    },
    formatDate(date, format) {
      return moment(date).format(format);
    },
    checkInDate(start_date) {
      if (
        this.date_range != "" &&
        moment(start_date) <= moment(this.date_range.end)
      ) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss">
.mini-calendar__event {
  display: flex;
  color: $text-color;

  &-date {
    padding-right: rem(10);
    color: $text-color1;
  }

  &-month {
    font-size: rem(20);
    text-transform: uppercase;
    display: block;

    &:after {
      content: "";
      height: 1px;
      width: rem(16);
      background: $background-color2;
      display: block;
    }
  }

  &-day {
    font-size: rem(30);
    font-weight: bold;
    line-height: 1.5;

    &.in-range {
      display: flex;
      width: rem(44);
      height: rem(44);
      align-items: center;
      justify-content: center;
      border: 1px solid $border-color;
      border-radius: 50%;
      margin-top: rem(5);
    }
  }

  &-time {
    > span:first-child::after {
      content: "|";
      margin: 0 rem(10);
    }
  }

  &-main {
    @include tablet-landscape-up {
      // display: flex;
      // flex-wrap: wrap;
      // gap: rem(10);
    }
  }

  &-title {
    margin: rem(10) 0 rem(10);
    @include desktop-up {
      margin: 0 0 rem(10);
    }

    a {
      color: $text-color1;
      @include desktop-xl-up {
        line-height: 1.5;
        margin-bottom: rem(20);
      }
    }
  }

  &-content {
    @include tablet-landscape-up {
      /*flex: 0 1 auto;
        width: calc(70% - 10px);*/
    }
  }

  &-media {
    display: none;

    img {
      width: auto;
      display: block;
    }

    @include mobile-xl-up {
      display: block;

      img {
        width: auto;
      }
    }

    @include desktop-up {
      width: 30%;
      float: left;
      margin: 0 rem(16) rem(8) 0;

      img {
        width: 100%;
      }
    }
  }

  &-caption {
    margin: 0;
    margin-bottom: 10px;
    line-height: 1.5;
  }

  &-summary {
    @include desktop-xl-up {
      /*padding-left: calc(30% + 10px);
        transform: translateY(-20px);*/
    }
  }

  &-line {
    display: flex;
    justify-content: flex-end;
  }

  &-social {
    .icon-path {
      fill: $text-color1;
    }

    .icon-facebook {
      width: rem(10);
    }
  }

  &-link {
    width: 180px;
    text-align: center;
    margin: rem(4);

    &:hover {
      background-color: $background-color3;
      color: $text-color2;

      .icon-path {
        fill: $text-color2;
      }
    }
  }
}
</style>
